// extracted by mini-css-extract-plugin
export default {"zoomModal":"o3-z","image":"p3-z","button":"q3-z","isOverlayShown":"r3-z"};